export default __webpack_public_path__ + "static/17-8b5cb359b4017605da8c3f505ef8ad58.png";